module.exports = __webpack_public_path__ + "static/media/icon-file-icon.c365df4a.svg";